import {
  ConsentGoalDto,
  NeedDto,
  SurveyV2,
  UserDto,
} from '@act/shared/data-transfer-objects';
import { Goal } from './types';
import { AssignedSurveyGoalCard } from './components/goalCards/AssignedSurveyGoalCard';
import { ConsentGoalCard } from './components/goalCards/ConsentGoalCard';
import { NeedGoalCard } from './components/goalCards/NeedGoalCard';
import { Dictionary } from '@act/shared/types';
import { ForwardedRef, forwardRef } from 'react';
import { Box } from '@mui/material';
import { GoalCardActionItems } from './shared-types';

export type { GoalCardActionItems };

export type CollapsibleGoalCardProps = {
  goal: Goal;
  member: UserDto;
  userMap?: Dictionary<UserDto>;
  actions?: GoalCardActionItems[];
  defaultClosed?: boolean;
  onToggleOpen?: () => void;
  summary?: JSX.Element;
};

export const CollapsibleGoalCard = forwardRef<
  HTMLDivElement,
  CollapsibleGoalCardProps
>(
  (
    {
      goal,
      member,
      userMap,
      actions,
      defaultClosed = false,
      onToggleOpen,
      summary,
    }: CollapsibleGoalCardProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    let goalCard: JSX.Element = null;

    if (goal.goalType === 'consent') {
      goalCard = (
        <ConsentGoalCard
          consent={goal as ConsentGoalDto}
          actions={actions}
          defaultClosed={defaultClosed}
          onToggleOpen={onToggleOpen}
        />
      );
    }
    if (goal.goalType === 'need') {
      goalCard = (
        <NeedGoalCard
          need={goal as NeedDto}
          member={member}
          userMap={userMap}
          actions={actions}
          defaultClosed={defaultClosed}
          onToggleOpen={onToggleOpen}
        />
      );
    }
    if (goal.goalType === 'survey') {
      goalCard = (
        <AssignedSurveyGoalCard
          assignedSurvey={goal as SurveyV2.AssignedSurveyDto}
          member={member}
          actions={actions}
          defaultClosed={defaultClosed}
          summary={summary}
          onToggleOpen={onToggleOpen}
        />
      );
    }

    return goalCard ? (
      <Box component="div" ref={ref}>
        {goalCard}
      </Box>
    ) : null;
  }
);

CollapsibleGoalCard.displayName = 'CollapsibleGoalCard';
